import { Link } from "react-router-dom";
import { Paper, ScrollArea, Button, ThemeIcon, Center, Loader, Tabs, Text, useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { IconTrash, IconUser } from "@tabler/icons-react";
import cx from "clsx";

import { ListUserDto } from "../../models/user.models";
import { useSearch } from "../../functions/SearchBox.hook";
import { useFilteredUsers } from "../../functions/user-filter.hooks";
import { NoSearchResults } from "../Shared/NoSearchResults";
import classes from './UserList.module.css';

interface UserListProps {
	users?: ListUserDto[] | undefined;
	isLoading?: boolean;
	selectedUser?: ListUserDto | null;
	setSelectedUser?: (user: ListUserDto | null) => void;
	setSelectedTab?: (tab: string | null) => void;
}
export const UserList = ({ users, isLoading, selectedUser, setSelectedUser, setSelectedTab }: UserListProps) => {
	const theme = useMantineTheme();
	const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`, true);
	const { query, setQuery } = useSearch();
	const { filteredUsers, showNoResults } = useFilteredUsers(users || []);

	if (isLoading) return <Paper withBorder p={0} radius="md" style={{ overflow: 'hidden' }}>
			<ScrollArea type={isMobile ? "never" : "scroll"} style={{ height: isMobile ? 'unset' : 'calc(100vh - 160px)', minHeight: isMobile ? 'calc(100vh - 150px)' : 'calc(100vh - 160px)' }} >
				<Center>
					<Loader size="sm" mt="lg" />
				</Center>
			</ScrollArea>
		</Paper>

	const handleUserSelect = (e: React.MouseEvent<HTMLAnchorElement>, user: ListUserDto): void => {
		e.preventDefault();
		setSelectedUser?.(user);
	}

	return <>
		<Paper withBorder p={0} radius="md" style={{ overflow: 'hidden' }}>
			<ScrollArea type={isMobile ? "never" : "hover"} style={{ height: isMobile ? 'unset' : 'calc(100vh - 160px)', minHeight: isMobile ? 'calc(100vh - 150px)' : 'calc(100vh - 160px)' }} >
				<Tabs value="users" onChange={setSelectedTab} defaultValue="users" radius="md" className={classes.tabs}>
					<Tabs.List grow>
						<Tabs.Tab value="users">Users</Tabs.Tab>
						<Tabs.Tab value="teams">Teams</Tabs.Tab>
					</Tabs.List>
					<Tabs.Panel value="users">
						{filteredUsers?.map(user => (
							<Button key={user.UserId}
								component="a"
								href={`/users/${user.UserId}`}
								onClick={(e) => handleUserSelect(e, user)}
								className={cx(classes['user-list-item'], { [classes['selected-item']]: selectedUser?.UserId === user.UserId })}
								leftSection={
									<ThemeIcon radius="xl"
										color={user.Deleted ? "red" : "blue"}
										size="xl"
										style={{ border: `1px solid var(--mantine-color-default-border)` }}
										variant="light"
									>
										{!user.Deleted ? <IconUser size={24} /> : <IconTrash size={24} />}
									</ThemeIcon>
								}
							>
								<Text c={user.Deleted ? "dimmed" : ""}>{user.Name}</Text>
							</Button>
						))}
						{showNoResults && <NoSearchResults searchType="users" query={query} setQuery={setQuery} />}
					</Tabs.Panel>
				</Tabs>
			</ScrollArea>
		</Paper>
	</>
}
